/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Assign_Driver_TitleInputs */

const vi_assign_driver_title = /** @type {(inputs: Assign_Driver_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chọn tài xế giao đơn`)
};

/**

* @param {Assign_Driver_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const assign_driver_title = /** @type {((inputs?: Assign_Driver_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assign_Driver_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_assign_driver_title(inputs)
});